module.exports = __webpack_public_path__ + "img/data_empty.2b3bf9c3.png";